<h2 mat-dialog-title>Share History by Facility</h2>

<mat-dialog-content>
  <div *ngIf="sortedRows.length === 0" class="empty-state">
    <mat-icon>history</mat-icon>
    <span>No studies have been shared for this patient yet.</span>
  </div>

  <table *ngIf="sortedRows.length > 0" mat-table [dataSource]="sortedRows" class="history-table">

    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef>Facility</th>
      <td mat-cell *matCellDef="let row">{{ row.facilityName || row.facilityId }}</td>
    </ng-container>

    <ng-container matColumnDef="lastShared">
      <th mat-header-cell *matHeaderCellDef>Last Shared</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.latestShare">{{ formatDate(row.latestShare.shared_at) }}</span>
        <span *ngIf="!row.latestShare" class="never-shared">Never shared</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.latestShare" class="status-chip" [class]="statusClass(row.latestShare)">
          {{ statusLabel(row.latestShare) }}
        </span>
        <span *ngIf="!row.latestShare" class="never-shared">—</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="expiry">
      <th mat-header-cell *matHeaderCellDef>Expiry</th>
      <td mat-cell *matCellDef="let row">
        <span *ngIf="row.latestShare">{{ expiryText(row.latestShare) }}</span>
        <span *ngIf="!row.latestShare">—</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
